import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverlayBackground = styled.div.withConfig({
  displayName: "MobileSidebarOverlay__OverlayBackground",
  componentId: "x3h8nk-0"
})(({
  theme
}) => ({
  backgroundColor: theme.color['fill-field-default'],
  opacity: 0.7,
  zIndex: -1,
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}));
const MobileSidebarOverlay = ({
  modalMessageKey = 'addModule.mobile.message.default',
  messageTitle = 'addModule.mobile.title',
  contextual = true
}) => {
  return /*#__PURE__*/_jsxs(Overlay, {
    contextual: contextual,
    use: "light",
    width: "100%",
    overflow: "hidden",
    paddingBlock: "0",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(OverlayBackground, {}), /*#__PURE__*/_jsxs(View, {
      inlineSize: "300px",
      marginBlock: "1000",
      marginInline: "auto",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "lock",
        width: "40%"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: messageTitle
        })
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: modalMessageKey
      })]
    })]
  });
};
export default MobileSidebarOverlay;